let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("krpZ0")).then(() => parcelRequire('eg5sT'));